<template>
    <div>
        <div class="content" style="width: auto">
            <div class="cont-list">
                <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
            </div>
     
            <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
                <div class="edit-card">
                    <div style="width: 88%; display: flex">
                        <div class="start-label" />
                        <span class="text">计划基础信息</span>
                    </div>
                    <el-row>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="no" v-if="getIsView()" label="计划单号">
                                <el-input disabled v-model="form.no"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 计划单号:{{ form.no }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="deptId" label="需求科室" v-if="getIsView()">
                                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" placeholder="请选择需求科室" :disabled="!editMode" style="width: 100%" filterable :filter-method="getWarehousesDeptWards" @change="deptChange1">
                                    <el-option v-for="(item,index) in STATIC_Depts" :key="index" :label="item.deptNo+' '+item.deptName + ' ' + (item.wardName ? item.wardName : '')" :value="item.idGroup"></el-option>
                                </el-select>
                                <el-select v-else v-model="form.deptName" placeholder="请选择需求科室" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDepts" @change="deptChange">
                                    <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else> 需求科室:{{ form.deptName }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="warehouseName" label="需求库房" v-if="getIsView()">
                                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择需求库房" style="width: 100%" filterable :filter-method="getWarehouses" @change="warehouseChange">
                                    <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else> 需求库房:{{ form.warehouseName }}</span>
                        </el-col>
     
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="oneLevelWarehouseId" label="收货库房" v-if="getIsView()">
                                <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !purchaseDataDisabled" placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehouseList" @change="oneLevelWarehouseChange">
                                    <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else> 收货库房:{{ form.oneLevelWarehouseName }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="categoryName" label="采购类型" v-if="getIsView()">
                                <el-select v-model="form.category" :disabled="!editMode && !purchaseDataDisabled">
                                    <el-option label="普通采购" :value="0"></el-option>
                                    <el-option label="临时采购" :value="1"></el-option>
                                    <el-option label="科研采购" :value="4"></el-option>
                                    
                                </el-select>
                                <!-- <el-radio-group :disabled="!purchaseDataDisabled" v-model="form.category">
                                    <el-radio :label="0">普通采购</el-radio>
                                    <el-radio :label="1">临时采购</el-radio>
                                </el-radio-group> -->
                            </el-form-item>
                            <span class="viewText" v-else> 采购类型:{{  form.category === 0 ? '普通采购' : (form.category === 1 ? '临时采购' : (form.category === 4 ? '科研采购' : '其他采购')) }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item label="创建时间" v-if="getIsView()" prop="createdTime">
                                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                            <span class="viewText" v-else> 创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                                <el-input disabled v-model="form.createdUserName"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 发起人:{{ form.createdUserName }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                                <el-input disabled v-model="form.ownerDeptName"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 所属科室:{{ form.ownerDeptName }}</span>
                        </el-col>
                        <el-col :span="8" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="备注" prop="remark">
                                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 备注:{{ form.remark }}</span>
                        </el-col>
                    </el-row>
     
                    <el-row>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="pressingState" label="紧急标识" v-if="getIsView()">
                                <el-select v-model="form.pressingState" :disabled="!editMode" placeholder="请选择" style="width: 100%">
                                    <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else> 紧急标识:{{  OrderPressingOptions.find(item => item.id === form.pressingState)?.name  }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="latestTime" label="最迟确认日期" v-if="getIsView()">
                                <el-date-picker v-model="form.latestTime" :disabled="!editMode && !purchaseDataDisabled" @change="latestTimeChange" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%" placeholder="确认日期"></el-date-picker>
                            </el-form-item>
                            <span class="viewText" v-else> 最迟确认日期:{{   parseTime(new Date(form.latestTime), "{y}-{m}-{d}") }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="deliveryTime" label="要求送达日期" v-if="getIsView()">
                                <el-date-picker v-model="form.deliveryTime" :disabled="!editMode && !purchaseDataDisabled" size="small" type="date" format="yyyy-MM-dd" style="width: 100%" value-format="yyyy-MM-dd" placeholder="送达日期"></el-date-picker>
                            </el-form-item>
                            <span class="viewText" v-else> 要求送达日期:{{   parseTime(new Date(form.deliveryTime), "{y}-{m}-{d}") }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
                        </el-col>
     
                    </el-row>
                    <el-row style="margin-top: 20px"></el-row>
                </div>
     
                <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
                    <div style="width: 88%; display: flex">
                        <div class="start-label" />
                        <span class="text">采购计划明细</span>
                    </div>
     
                    <div v-if="editMode || purchaseNumberDisabled" style="margin: 20px 0 12px 10px">
                        <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                        <el-button :class="childMultiple?'btn' :'btn default'" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
                        <el-button :class="childMultiple?'btn' :'btn default'" size="small" :disabled="childMultiple" v-preventReClick @click="correctProcureNum">修正采购量(按件装量)</el-button>
                        <el-button class="btn default" v-if="this.form.status == 1 && this.form.warehouseCategory == 2" style="float: right; margin: 3px; background: #286ab4; color: beige" size="small" v-preventReClick @click="monthAvgChange">计算</el-button>
                        <div class="block" style="float: right" v-if="this.form.status == 1 && this.form.warehouseCategory == 2">
                            <el-tooltip class="item" effect="dark" content="设置请领时间的区间范围，用于统计【月均请领数量】，系统默认已过去的最近三个月，可自行修改后重新计算" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                            <span class="demonstration">请领时间：</span>
                            <el-date-picker v-model="monthAvgDate" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                    </div>
                    <div v-else style="margin-top: 20px"></div>
     
                    <el-table ref="childTable" border :data="form.details" :max-height="400" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                        <el-table-column type="index" width="50" fixed="left"> </el-table-column>
                        <el-table-column type="selection" width="55" fixed="left" align="center"></el-table-column>
                        <el-table-column prop="productName" label="产品" fixed="left" width="180">
                            <template slot-scope="scope">
                                <SelectTable v-if="system_setting.purchasePlanSupplierProductRange == '0'" :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
     
                                <SelectTable v-else :disabled="!editMode" :columns="applySupplierProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_ApplySupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="specName" label="产品规格" fixed="left" width="120"></el-table-column>
     
                        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
                        <el-table-column prop="pressingStateName" width="80" label="紧急标识">
                            <template slot-scope="scope">
                                <span :class="getPressingStateClass(scope.row.pressingState)">{{
                      scope.row.pressingStateName
                    }}</span>
                            </template>
                        </el-table-column>
     
                        <el-table-column prop="applyNumber" label="申请数量" width="80">
                            <template slot-scope="scope">
                                <span>{{ scope.row.applyNumber?scope.row.applyNumber:'-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" label="采购数量" width="110">
                            <template slot-scope="scope">
                                <el-input  :disabled="!editMode && !purchaseNumberDisabled" placeholder="请输入数量" type="number" min="0" @input="inputChange(scope.row)" v-model="scope.row.number"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="avgApplyNumber" v-if="this.form.status == 1 && this.form.warehouseCategory == 2" label="月均请领数量" :key="'avgApplyNumber'" width="110"></el-table-column>
                        <el-table-column prop="monthAvgUseNumber" v-if="(this.form.status == 1 || this.form.status == undefined)&& this.form.warehouseCategory == 2" :key="'monthAvgUseNumber'" label="月均消耗数量" width="110"></el-table-column>
                        
                        <el-table-column prop="recommendation" label="建议采购量(按件装量)" min-width="170">
                            <template slot-scope="scope">
                                {{ scope.row.recommendation?scope.row.recommendation:'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                        <el-table-column prop="packNumber" label="件装量" width="80">
                            <template slot-scope="scope">
                                {{ scope.row.packNumber?(scope.row.packNumber+scope.row.minUnit+'/'+scope.row.unit):'-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="packSpec" label="包装规格" width="100"></el-table-column>
                        <el-table-column prop="price" label="采购价" width="80"></el-table-column>
                        <el-table-column prop="amount" label="小计" width="80"></el-table-column>
                        <el-table-column prop="deptStockNumber" label="科室库存" width="80"></el-table-column>
                        <el-table-column prop="stockNumber" label="中心库存" width="80"></el-table-column>

                        <el-table-column prop="isDistribution" label="集采标识" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isDistribution?'是':'否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="180"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="150"></el-table-column>
                        <el-table-column prop="procurecatalogId" v-if="this.system_setting.isUsePriceMonitor" label="商品代码" width="100"></el-table-column>
                        <el-table-column prop="goodsId" v-if="this.system_setting.isUsePriceMonitor" label="平台产品id" width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.goodsId?scope.row.goodsId:'-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="minPrice" v-if="this.system_setting.isUsePriceMonitor" label="平台最低价" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.onlineNo?scope.row.onlineNo:'-' }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="brand" label="品牌" width="100"></el-table-column> -->
                        <el-table-column prop="remark" label="备注" width="200">
                            <template slot-scope="scope">
                                <el-input :disabled="!purchaseNumberDisabled" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
                        <el-table-column v-if="system_setting.isShowSecondSupplier" prop="secondSupplierName" show-overflow-tooltip
                      width="140" label="二级供应商">
                      <template slot-scope="scope">
                        {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
                      </template>
                </el-table-column>
                        <el-table-column fixed="right" width="160" label="完成情况">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.inStockNumber, scope.row.number)" color="#42b983" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
     
                <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
                    <div style="width: 88%; display: flex">
                        <div class="start-label" />
                        <span class="text">申请明细</span>
                    </div>
     
                    <!-- <div v-if="editMode" style="margin: 20px 0 12px 10px">
                <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
              </div>
              <div v-else style="margin-top: 20px"></div> -->
     
                    <el-table ref="childTable" border :data="applyDetails" style="width: auto; margin: 0 10px" stripe :header-cell-style="{ background: '#DDEBFF' }">
                        <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180"></el-table-column>
     
                        <el-table-column prop="deptName" label="科室名称" fixed="left" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="specName" fixed="left" label="产品规格" width="180"></el-table-column>
     
                        <el-table-column prop="warehouseName" label="仓库名称" width="100"></el-table-column>
                        <el-table-column prop="pressingStateName" width="80" label="紧急标识">
                            <template slot-scope="scope">
                                <span :class="getPressingStateClass(scope.row.pressingState)">{{
                      scope.row.pressingStateName
                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="brand" label="品牌" width="90"></el-table-column> -->
                        <el-table-column prop="unit" label="包装单位" width="90"></el-table-column>
                        <el-table-column prop="minUnit" label="最小单位" width="90"></el-table-column>
                        <el-table-column prop="stockNumber" label="库存数量" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="120"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="180"></el-table-column>
                        <el-table-column prop="number" label="申请数量" width="100"></el-table-column>
                        <el-table-column prop="receivedNumber" label="已领数量" width="100"></el-table-column>
                        <el-table-column prop="notReceivedNumber" label="未领数量" width="100"></el-table-column>
                        <el-table-column prop="planOrderNumber" label="采购数量" width="120">
                            <template slot-scope="scope">
                                <el-input :disabled="!editMode && !purchaseDataDisabled" placeholder="请输入数量" type="number" min="0" @input="applyDetailNumberChange(scope.row)" v-model="scope.row.planOrderNumber"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="单价" width="120"></el-table-column>
                        <el-table-column prop="amount" label="小计" width="120"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200">
                        </el-table-column>
                    </el-table>
                </div>
     
                <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
            </el-form>
        </div>
        <div slot="footer" class="footer-bottom">
            <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
            <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
            <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
            <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
                定</my-button>
            <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
        </div>
     
        <el-dialog title="提示" :visible.sync="correctBox" width="400" :before-close="handleClose">
            <h4>您确定对下列产品的采购数量按建议采购量做如下修正吗？</h4>
            <el-table border :data="childMultipleSelection" :max-height="400" style="width: auto; margin: 0 10px" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column prop="productName" label="产品名称" min-width="110"></el-table-column>
                <el-table-column prop="specName" label="规格型号" min-width="110"></el-table-column>
                <el-table-column prop="number" label="原采购量" min-width="110"></el-table-column>
                <el-table-column prop="recommendation" label="建议采购量(按件装量)" min-width="120"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="correctBox = false">取 消</el-button>
                <el-button type="primary" @click="correctEvt">确 定</el-button>
            </span>
        </el-dialog>
    </div>
    </template>
     
    <script>
    import GetDataMixin from "@/mixin/getData-mixin.js";
    import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
    import {
        SpdGetPurchasePlanById,
        SpdSavePurchasePlan,
        SpdRejectPurchasePlan,
        GetOneLevelStockNumber,
        GetApplyDetailsBySupplierProductId,
        GetApplyDetailsByPlanId,
        GetDeptWarehouses,
        GetPurchasePlanViewModelByApplyIds,
        GetGoods,
        PurchasePlanChaoLiangValidate,
        GetMonthAvgApplyNumber,
        GetSupplierProducts,
        ValidateUnfinishedPurchasePlanDetail,
    } from "@/api";
    import {
        InStockOptions,
        WhetherOptions,
        AssetSourceOptions,
        OrderPressingOptions,
    } from "@/enum";
    import SelectTable from "@/components/select-table";
    import ApproveInfo from "@/components/approve-info";
     
    export default {
        name: "purchaseApplyEdit",
        mixins: [GetDataMixin, GetDataSpdMixin],
        components: {
            SelectTable,
            ApproveInfo,
        },
        data() {
            return {
                form: {},
                InStockOptions: InStockOptions,
                WhetherOptions: WhetherOptions,
                AssetSourceOptions: AssetSourceOptions,
                OrderPressingOptions: OrderPressingOptions,
                rules: {
                    latestTime: [{
                        required: true,
                        message: "请选择日期",
                        trigger: "blur",
                    }, ],
                    deliveryTime: [{
                        required: true,
                        message: "请选择日期",
                        trigger: "blur",
                    }, ],
                    deptId: [{
                        required: true,
                        message: "请选择需求科室",
                        trigger: "blur",
                    }, ],
                    warehouseName: [{
                        required: true,
                        message: "请选择需求库房",
                        trigger: "blur",
                    }, ],
                    oneLevelWarehouseId: [{
                        required: true,
                        message: "请选择收货库房",
                        trigger: "blur",
                    }, ],
                    pressingState: [{
                        required: true,
                        message: "请选择紧急标识",
                        trigger: "blur",
                    }, ],
                },
                childFormRules: {
                    price: [{
                        required: true,
                        message: "请输入采购价",
                        trigger: "blur",
                    }, ],
                    number: [{
                            required: true,
                            message: "数量不能为空",
                            trigger: "blur",
                        },
                        {
                            type: "number",
                            min: 0.01,
                            message: "数量必须大于0",
                            trigger: "blur",
                        },
                    ],
                },
                editMode: false,
                showWorkFlowInfo: false,
                assetList: [],
                reject: SpdRejectPurchasePlan,
                // 子表
                childIds: [],
                childMultipleSelection: [],
                childMultiple: true,
                childForm: {},
                avgApplyNumber: 0, //月平均请领数量
                warehouseList: [],
                applyDetails: [],
                applyCacheDetails: [],
                purchaseDataDisabled: false,
                purchaseNumberDisabled: false,
                monthAvgDate: [],
                dialogVisible: false,
                dialogData: [],
                correctBox: false,
                isCopy: false,
            };
        },
     
        created() {
            var query = this.$route.query;
            if (query.id) {
                this.handleUpdate(query.id);
            } else {
                this.handleAdd();
            }
            if (this.system_setting.IsUseWard) {
                this.getWarehousesDeptWards()
     
            } else {
                this.getDepts("");
            }
            this.getWarehouses("");
              this.getOneLevelWarehouseList("");
            if (query.isCopy == 1) {
                this.isCopy = true;
            }
            var params = this.$route.params;
            // console.log("params.applyIds", params.applyIds);
            if (params.applyIds && params.applyIds.length > 0) {
                this.getPurchasePlanByApplyIds(params.applyIds);
            }
     
            var year = new Date().getFullYear();
            var month = new Date().getMonth();
            let startDate = new Date("1970-1-1 8:00:00");
            let endDate = new Date("1970-1-1");
     
            let startMonth = month - 3;
            let endMonth = month;
            startDate.setFullYear(year);
            endDate.setFullYear(year);
            startDate.setMonth(startMonth);
            endDate.setMonth(endMonth);
            startDate.setDate(1);
            endDate.setDate(1);
     
            // var startDate = new Date(`${year}-${month - 2}-1 8:00:00`)
            // var endDate = new Date(`${year}-${month + 1}-1`)
            this.monthAvgDate = [new Date(startDate), new Date(endDate - 1)];
            // this.getProductList("");
            // this.getOneLevelWarehouses("");
        },
        methods: {
            // 新建
            handleAdd() {
                this.resetForm();
                this.editMode = true;
                this.purchaseNumberDisabled = true;
                this.purchaseDataDisabled = true;
            },
            // 编辑
            handleUpdate(id) {
                SpdGetPurchasePlanById({
                    id,
                }).then((res) => {
                    // this.resetForm()
                    this.form = res.returnData;
                    if (this.isCopy) {
                        this.form.id = 0;
                        this.form.no = "";
                        this.form.status = 2;
                        this.form.applyStatus = 0;
                        this.form.state = 0;
                        this.form.category = 0;
                        this.form.workFlowInstanceId = 0;
                        let now = this.parseTime(new Date());
                        let user = this.userInfo;
                        this.form.createdUserName = user.name;
                        this.form.createdUser = user.id;
                        this.form.ownerDept = user.deptId;
                        this.form.ownerDeptName = user.deptName;
                        this.form.createdTime = now;
                        this.form.effectiveTime = null

                        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
     
                        if (this.form.details) {
                            let query = {
                                ids: supplierProductIds,
                                isEnabled: 1,
                                status: 2,
                                supplierApproveStates: [2],
                                warehouseId: this.form.oneLevelWarehouseId,
                                oneLevelWarehouseId: this.form.oneLevelWarehouseId,
                                secondWarehouseId: this.form.warehouseId,
                            }
                            GetSupplierProducts(query).then(res => {
                                this.form.details.forEach(v => {
                                    res.returnData.data.forEach(k => {
                                        if (v.supplierProductId == k.id) {
                                            v.price = k.purchasePrice
                                            v.amount = (k.purchasePrice * v.number)
                                            v.deptStockNumber = k.deptStockQuantity
                                            v.stockNumber = k.stockQuantity
                                            v.secondSupplierId = k.secondSupplierId
                                            v.secondSupplierName = k.secondSupplierName
                                            v.isDistribution = k.isDistribution
                                        }
                                    })
                                })
                                this.autoTotalAmount()
                            }).then(() => {
                                this.form.details.map((item) => {
                                    item.receivedNumber = 0;
                                    item.notReceivedNumber = item.number;
                                    item.state = 0;
                                    item.stateName = "";
                                })
                            })
                        }
                    }
                    this.getLocations(this.form.warehouseId);
                    this.form.details.forEach((e, index) => {
                        e.$index = index + 1;
                        // this.getGoods(e, 2)
                    });
     
                    this.initWorkFlowProperty(this.form);
     
                    if (this.formMode == 1) {
                        this.purchaseNumberDisabled = false;
                        this.purchaseDataDisabled = false;
                    }
     
                    if (
                        this.formMode == 3 &&
                        this.form.status == 1 &&
                        this.form.approverIds &&
                        this.form.approverIds.split(";").indexOf(this.userInfo.id + "") != -1
                    ) {
                        this.purchaseNumberDisabled = true;
                        this.purchaseDataDisabled = true;
     
                        this.initNumberDisable();
                    }
                    if (this.form.status == 1) {
                        this.monthAvgChange();
                    }
                });
            },
            // 保存
            submit() {
                this.$store.dispatch('SetLoading', true)
     
                this.$refs["form"].validate((valid) => {
                    if (!valid) {
                        this.$store.dispatch('SetLoading', false)
                        return false;
                    }
     
                    var productValidate = this.orderProductDetailRepeatValidate(this.form.details);
                    if (!productValidate.flag) {
                        this.$my_message(productValidate.msg, "warning");
                        this.$store.dispatch('SetLoading', false)
                        return;
                    }
     
                    var minusNumberValidate = this.minusNumberValidate(this.form.details);
                    if (!minusNumberValidate.flag) {
                        this.$my_message(minusNumberValidate.msg, "warning");
                        this.$store.dispatch('SetLoading', false)
                        return;
                    }
     
                    let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
                    if (!supplierProductIds || supplierProductIds.length == 0) {
                        this.$my_message("存在没有供应商产品的明细表", "warning");
                        this.$store.dispatch('SetLoading', false)
                        return;
                    }
                    const h = this.$createElement;
                    let show = false
                    let content = [h("p", "")];
                    this.form.details.forEach((item, index) => {
                        if (item.number < item.recommendation) {
                            show = true
                            content.push(h("p", `第${index + 1}行：产品名称 [${item.productName
                  }] 采购数量不满足件装量要求`))
     
                        }
                    })
                    let _this = this
                    let fn = function () {
                        PurchasePlanChaoLiangValidate(_this.form).then(res => {
                            if (res.length !== 0) {
                              _this.dialogVisible = true
                              _this.dialogData = res
     
                            } else {
                                let pressingDetails = _this.form.details.filter((e) => e.pressingState == 1);
                                if (
                                    (_this.formMode == 1 || _this.formMode == 2) &&
                                    _this.form.pressingState != 1 &&
                                    pressingDetails &&
                                    pressingDetails.length >= 1
                                ) {
                                  _this.$confirm("提示", {
                                            title: "提示",
                                            type: "warning",
                                            showClose: false,
                                            message: `该采购计划有${pressingDetails.length}条紧急计划明细，是否将本条计划标为紧急？`,
                                        })
                                        .then(() => {
                                          _this.form.pressingState = 1;
                                          _this.save();
                                        })
                                        .catch(() => {
                                          _this.$store.dispatch('SetLoading', false)
                                          _this.save();
                                        });
                                } else {
                                  _this.save();
                                }
     
                            }
                        })
                    }
                    let ValidateUnfinishedPurchasePlan = function () {
                        ValidateUnfinishedPurchasePlanDetail(_this.form).then(res => {
                            if (!res.returnData.successful) {
                                _this.$confirm("提示", {
                                        title: "提示",
                                        type: "warning",
                                        showClose: false,
                                        message: res.returnData.errorMessage,
                                    })
                                    .then(() => {
                                        fn()
                                    })
                                    .catch(() => {
                                        _this.$store.dispatch('SetLoading', false)
                                    });
                            } else {
                                fn()
                            }
                        })
                    }
     
                    if (show) {
                        content.push(h("p", "如要修改请点击【取消】，如果不修改，请点击【确定】"))
                        this.$confirm("提示", {
                            title: "提示",
                            type: "warning",
                            showClose: false,
                            message: h("div", content),
                        }).then(() => {
                            setTimeout(() => {
                                if(this.$route.query.formMode == 1){
                                    ValidateUnfinishedPurchasePlan()
                                }else{
                                  fn()
                                }
                              
                            });
                            
                        }).catch(() => {
                            this.$store.dispatch('SetLoading', false)
                        })
                        this.$store.dispatch('SetLoading', false)
                        return
                    }
                    if(this.$route.query.formMode == 1){
                        ValidateUnfinishedPurchasePlan()
                    }else{
                        fn()
                    }
                   
     
                });
            },
     
            save() {
                let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
                this.form.applyDetails = this.form.applyDetails;
                GetSupplierProducts({
                        ids: supplierProductIds,
                        pageIndex: 1,
                        pageSize: 999,
                    })
                    .then((res) => {
                        let msg = "";
                        for (let i = 0; i < this.form.details.length; i++) {
                            let sp = res.returnData.data.find(
                                (e) => e.id == this.form.details[i].supplierProductId
                            );
                            // console.log(sp, 'sp', sp.isEnabled != 1, this.form.details[i].number, this.form.details[i].oneLevelStockNumber)
                            if (sp && sp.isEnabled != 1) {
                                msg = `第${i + 1}行：产品名称 [${this.form.details[i].productName
                    }] 规格型号 [${this.form.details[i].specName
                    }]的产品<span style="color:red">已被禁用</span>`;
                                break;
                            }
                        }
     
                        if (msg) {
                            this.$my_message(msg, "warning");
                            this.$store.dispatch('SetLoading', false)
                            throw msg;
                        }
                        if(this.$route.query.formMode == 1||this.$route.query.formMode==2){
                            this.form.details.forEach(i=>{
                              i.isDistribution = null
                            })
                        }
                        return SpdSavePurchasePlan(this.form).finally(() => {
                            this.$store.dispatch('SetLoading', false)
                        });;
                    })
                    // SpdSavePurchasePlan(this.form)
                    .then((res) => {
                        this.$my_message(`执行成功`, "success");
                        sessionStorage.setItem("editMode", 0);
                        // this.$router.push({ path: this.getMainPath(this.$route.path) });
                        if (this.$route.params.applyIds && this.$route.params.applyIds.length > 0) {
                            this.routePushWithParams(this.getMainPath(this.$route.path), {});
                        } else {
                            this.routePushWithParams(
                                this.getMainPath(this.$route.path),
                                this.$route.params
                            );
                        }
                    }).catch(() => {
                        this.$store.dispatch('SetLoading', false)
                    });;
            },
            resetForm() {
                this.form = {
                    totalNumber: 0,
                    totalAmount: 0,
                    category: 0,
                    remark: "",
                    pressingState: 0,
                    latestTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
                    deliveryTime: "",
                    details: [],
                    createdTime: this.parseTime(new Date()),
                    updateTime: this.parseTime(new Date()),
                    warehouseName: this.mySessionStorage.getWarehouseName(),
                    warehouseId: this.mySessionStorage.getWarehouseId(),
     
                    deptName: this.system_setting.IsUseWard ? `${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} ` : this.mySessionStorage.getDeptName(),
     
                    deptId: this.mySessionStorage.getDeptId(),
                    wardId: this.system_setting.IsUseWard ? this.mySessionStorage.getWardId() : '',
                    createdUserName: this.userInfo.name,
                    ownerDeptName: this.userInfo.deptName,
                    orgCode :sessionStorage.getItem('orgId'),
                    date: this.parseTime(new Date(), "{y}-{m}-{d}"),
                };
     
                if (this.system_setting.supProductFIrWarehouseDefault) {
                    this.getOneLevelWarehousesByOneLevelDeptId('', this.form.deptId).then(res => {
                        let arr = res.filter(k => k.no == this.system_setting.supProductFIrWarehouseDefault)
                        if (arr.length) {
                            this.$set(this.form, 'oneLevelWarehouseName', arr ? arr[0].name : "")
                            this.$set(this.form, 'oneLevelWarehouseId', arr ? arr[0].id : "")
                            this.$set(this.form, 'oneLevelWarehouseManagerId', arr ? arr[0].managerId : "")
                        }
                        // this.oneLevelWarehouseChange(arr[0].id)
     
                    })
     
                }
                this.getOneLevelWarehouseList('')
                this.latestTimeChange(this.form.latestTime);
            },
            // 取消编辑
            cancel() {
                this.$store.dispatch('SetLoading', false)
                // console.log(this.prevRoute, "this.prevRoute")
                if (this.prevRoute.path == "/") {
                    this.$router.go(-1);
                } else {
                    console.log(this.$route.params);
     
                    this.routePushWithParams(this.prevRoute.path, this.$route.params);
                }
            },
     
            // 明细表
            handleAddChildForm() {
                if (!this.form.warehouseId || this.form.warehouseId == "") {
                    this.$my_message("请先选择需求库房", "warning");
                    this.getProductList('')
                    return;
                }
                this.openSubformModal = true;
                this.editChildren = false;
                this.resetDetailFormData();
                this.form.details.push(this.childForm);
                this.autoTotalAmount();
                this.getProductList("");
            },
            handleDeleteChildForm() {
                this.form.details = this.form.details.filter(
                    (i) => !this.childIds.includes(i.$index)
                );
                this.form.details.forEach((e, index) => {
                    e.$index = index + 1;
                });
     
                this.autoTotalAmount();
            },
            handleChildSelectionChange(selection) {
                this.childMultipleSelection = selection;
                this.childIds = selection.map((item) => item.$index);
                this.childMultiple = !selection.length;
            },
            cellDblclick(row, column, cell, event) {
                // // 打开子表弹窗
                // this.openSubformModal = true;
                // this.editChildren = true;
                // this.resetDetailFormData();
                // this.childForm = JSON.parse(JSON.stringify(row));
                // this.childForm.details.forEach((e, index) => {
                //   e.$index = index + 1;
                // });
                this.showApplyData(row);
            },
     
            resetDetailFormData() {
                this.childForm = {
                    $index: this.form.details.length + 1,
                    no: "",
                    productName: "",
                    specName: "",
                    manufacturerName: "",
                    locationName: "",
                    mainNo: "",
                    traceNo: "",
                    productId: "",
                    specId: "",
                    productRegistCertNo: "",
                    onlineNo: "",
                    unit: "",
                    minUnit: "",
                    packSpec: "",
                    manufacturerId: "",
                    locationId: "",
                    manufactureDate: "",
                    batch: "",
                    validityDate: "",
                    serialNo: "",
                    number: 1,
                    price: 0,
                    amount: 0,
                    remark: "",
                    avgApplyNumber: 0,
                };
            },
            cancelChildDialog() {
                this.openSubformModal = false;
            },
            submitChildForm() {
                this.pushChildForm(true);
            },
            continueAdd() {
                this.editChildren = false;
                this.pushChildForm();
     
                this.getProductList("");
            },
            pushChildForm(close) {
                this.$refs["childForm"].validate((valid) => {
                    if (!valid) {
                        return false;
                    }
                    this.childForm.orgCode = sessionStorage.getItem('orgId')
                    // this.capitalSourceChange()
                    let item = this.form.details.find(
                        (e) =>
                        e.$index != this.childForm.$index &&
                        e.supplierProductId == this.childForm.supplierProductId //&&
                        // e.price == this.childForm.price &&
                        // e.locationName == this.childForm.locationName &&
                        // e.assetSource == this.childForm.assetSource &&
                        // e.packDesc == this.childForm.packDesc &&
                        // e.manufacturerId == this.childForm.manufacturerId &&
                        // e.certId == this.childForm.certId &&
                        // e.brandId == this.childForm.brandId
                    );
                    if (item && !this.editChildren) {
                        // 新增有重复项提示
                        // Object.assign(item, this.childForm);
                        this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
                        return;
                    } else if (item && this.editChildren) {
                        // 编辑且有重复项
                        this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
                        return;
                    } else if (!item && this.editChildren) {
                        // 编辑
                        item = this.form.details.find((e) => e.$index == this.childForm.$index);
                        Object.assign(item, this.childForm);
                    } else {
                        this.form.details.push(this.childForm);
                    }
     
                    this.autoTotalAmount();
                    this.resetDetailFormData();
                    if (close) {
                        this.openSubformModal = false;
                    }
                });
            },
            // childNumberChange () {
            //   this.childForm.notReceivedNumber = this.childForm.number
            //   this.childForm.planOrderNumber = this.childForm.number
            //   this.childForm.actualOrderNumber = this.childForm.number
            //   this.autoAmount();
            // },
            // autoAmount () {
            //   this.childForm.amount =
            //     (this.childForm.number * this.childForm.price).toFixed(4) * 1;
            //   this.childForm.unBillAmount = this.childForm.amount;
     
            //   this.autoTotalAmount()
            // },
            autoTotalAmount() {
                let totalNumber = 0;
                let totalAmount = 0;
                this.form.details.forEach((element, index) => {
                    // 重置表格数据的序号
                    element.$index = index + 1;
                    totalNumber = totalNumber * 1 + element.number * 1;
                    totalAmount = totalAmount * 1 + element.amount * 1;
                });
                this.form.totalNumber = totalNumber.toFixed(3) * 1;
                this.form.totalAmount = totalAmount.toFixed(4) * 1;
                this.form.unBillNumber = totalNumber;
                this.form.unBillAmount = totalAmount;
            },
     
            monthAvgChange() {
                console.log(
                    this.form.details,
                    this.monthAvgDate,
                    "this.form.details -monthAvgChange"
                );
     
                if (this.form.details && this.form.details.length > 0) {
                    this.form.details.forEach((e, index) => {
                        // e.$index = index + 1;
                        // 获取科室下面该产品的月平均采购数量
                        let query = {
                            supplierProductId: e.supplierProductId,
                            applyDeptId: this.form.deptId,
                            warehouseId:this.form.warehouseId,
                            startDate: this.monthAvgDate[0],
                            endDate: this.monthAvgDate[1],
                        };
                        console.log(this.monthAvgDate[0], "this.monthAvgDate[0] -monthAvgChange");
                        GetMonthAvgApplyNumber(query).then((res) => {
                            this.$set(e, "avgApplyNumber", res.returnData.monthAvgApplyNumber.toFixed(2) * 1);
                            this.$set(e, "monthAvgUseNumber", res.returnData.monthAvgUseNumber.toFixed(2) * 1);
                        });
                    });
                }
     
            
            },
            // change event
            productChange(row, val) {
                // let arr = this.STATIC_SupplierProducts.filter(item => item.id == val.id)
                let id = row.id;
                // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
                row = Object.assign(row, val); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
                row.id = id;
                row.supplierProductId = val.id;
                row.number = 1;
                row.stockNumber = val.stockQuantity;
                row.deptStockNumber = val.deptStockQuantity;
                row.price = row.purchasePrice;
                row.amount = row.price * row.number;
                row.supplierProductNo = row.no;
                row.remark = "";
                row.recommendation = val.packNumber ? val.packNumber : ''
                // GetOneLevelStockNumber({ supplierProductId: row.supplierProductId, stockCategory: 0 })
                //   .then(res => {
                //     row.stockNumber = res.returnData.stockNumber
                //   })
     
                this.autoTotalAmount();
     
                // 获取价格平台相关信息
                this.getGoods(row, 1);
            },
            getGoods(row, type) {
                // PriceMonitorType ：价格监管平台类型,0耗材，1试剂，2其他
                // type : 1新增 ，2 查看
                var goodsId = row.priceMonitorId;
                if (type == 2) {
                    goodsId = row.goodsId;
                }
                let arr = [];
                // console.log("type-GoodsId", row.goodsId, type, goodsId);
                GetGoods({
                    GoodsId: goodsId,
                    PriceMonitorType: row.priceMonitorType,
                }).then((res) => {
                    if (goodsId == null || goodsId === "") {
                        console.log("row", row);
                        // console.log("goodsId", goodsId, row.priceMonitorType)
                        // console.log("this.system_setting.isUsePriceMonitor", this.system_setting.isUsePriceMonitor);
                    } else {
                        row.goodsId = res.returnData.data[0].goodsId;
                        row.procurecatalogId = res.returnData.data[0].procurecatalogId;
                        // arr.push(res.returnData.data[0].lastMinPrice);
                        // arr.push(res.returnData.data[0].minPrice);
                        arr.push(res.returnData.data[0].maxPrice);
                        arr.push(res.returnData.data[0].avgPrice);
                        arr.push(res.returnData.data[0].linkageReferencePrice);
                        arr = arr.filter((e) => {
                            return e != undefined;
                        });
                        row.minPrice = arr.length > 0 ? Math.min(...arr) : "";
                        // console.log("arr", arr);
                        // console.log("row.minPrice", row.minPrice);
                    }
                });
            },
     
            deptChange(val) {
                this.form.deptId = val;
                this.getOneLevelWarehouseList("");
            },
            deptChange1(val) {
                let arr = this.STATIC_Depts.filter(res => res.idGroup == val)
                this.form.deptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
                this.form.deptId = arr[0].deptId
                this.form.wardId = arr[0].wardId
                this.getOneLevelWarehouseList("");
            },
            applyDeptChange1(val) {
                let arr = this.STATIC_Depts.filter(res => res.idGroup == val)
                this.form.warehouseName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
                this.form.warehouseId = arr[0].warehouseId
                this.form.deptId = arr[0].deptId
                this.form.wardId = arr[0].wardId
                this.getOneLevelWarehouseList('')
            },
            warehouseChange(val) {
                this.form.warehouseId = val;
            },
            inputChange(row) {
                row.amount = (row.price * row.number).toFixed(4) * 1;
                if (row.packNumber) {
                    row.recommendation = this.divideAndConditionallyAddOne(row.number, row.packNumber) * row.packNumber
     
                }
     
                this.autoTotalAmount();
            },
            excessEvt() {
                this.dialogVisible = false
                this.save()
            },
            getProductList(keyWord) {
                // query.pageSize = 50
                // query.pageIndex = 1
                // query.isEnabled = 1
                // query.status = 2
                if (this.system_setting.purchasePlanSupplierProductRange == "0") {
     
                    this.getSupplierProducts(
                        //query)
                        {
                            keyWord: keyWord,
                            pageSize: 50,
                            pageIndex: 1,
                            isEnabled: 1,
                            status: 2,
                            supplierApproveStates: [2],
                            warehouseId: this.form.oneLevelWarehouseId,
                            oneLevelWarehouseId: this.form.oneLevelWarehouseId,
                            secondWarehouseId: this.form.warehouseId,
                            // deptId: this.form.deptId
                        }
                    );
                } else {
                    let query = {
                        keyWord: keyWord,
                        pageIndex: 1,
                        pageSize: 50,
                        isEnabled: 1,
                        supplierApproveStates: [2],
                        deptId: this.form.deptId,
                        status: 2,
                        wardId: this.system_setting.IsUseWard ? this.form.wardId : '',
                        warehouseId: this.form.oneLevelWarehouseId,
                        secondWarehouseId: this.form.warehouseId,
                        applyOrPlan:2
                    };
                    // query.deptId = this.userInfo.deptId
     
                    this.getApplySupplierProducts(query);
                }
            },
            applyDetailNumberChange(row) {
                row.amount = (row.planOrderNumber * row.price).toFixed(4) * 1;
                // console.log(this.applyDetails)
                var arr = this.form.details.filter(
                    (e) => e.supplierProductId == row.supplierProductId
                );
                if (arr && arr.length > 0) {
                    let total = 0;
                    this.applyDetails.map((e) => {
                        total += e.planOrderNumber * 1;
                    });
     
                    arr[0].number = total;
                    arr[0].amount = (arr[0].number * arr[0].price).toFixed(4) * 1;
                }
     
                var cacheDetail = this.form.applyDetails.filter((e) => e.id == row.id);
                if (cacheDetail && cacheDetail.length > 0) {
                    cacheDetail.map((item) => {
                        return row;
                    });
                }
     
                this.autoTotalAmount();
                // console.log(this.form.applyDetails, "applyCacheDetails")
            },
            oneLevelWarehouseChange(val) {
                this.form.oneLevelWarehouseId = val;
                let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
                this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
                this.$forceUpdate()
                this.getProductList('')
            },
            latestTimeChange(val) {
                if (val) {
                    let confirmDate = new Date(val);
                    let t = this.parseTime(
                        new Date(confirmDate.setDate(confirmDate.getDate() + 3)),
                        "{y}-{m}-{d}"
                    );
                    this.form.deliveryTime = t;
                }
            },
     
            //other
            getWarehouseList(keyWord) {
                GetDeptWarehouses({
                    keyWord: keyWord,
                    state: 1,
                }).then((res) => {
                    this.warehouseList = res.returnData;
                });
            },
            getOneLevelWarehouseList(keyWord) {
                if (this.form.deptId) {
                    this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.deptId)
                } else {
                    this.STATIC_OneLevelWarehouses = []
                }
            },
     
            showApplyData(row) {
                if (!this.form.applyDetails) {
                    this.form.applyDetails = [];
                }
                var details = this.form.applyDetails.filter(
                    (e) => e.supplierProductId == row.supplierProductId
                );
                if (details && details.length > 0) {
                    this.applyDetails = details;
                    return;
                }
     
                if (!this.form.id || !row.supplierProductId) {
                    return;
                }
                GetApplyDetailsBySupplierProductId({
                    planId: this.form.id,
                    supplierProductId: row.supplierProductId,
                }).then((res) => {
                    this.applyDetails = res.returnData;
                    this.form.applyDetails = this.form.applyDetails.concat(this.applyDetails);
                });
            },
            initNumberDisable() {
                // 非请领单生成的采购计划，审批的时候，数量可编辑
                GetApplyDetailsByPlanId({
                    id: this.id,
                }).then((res) => {
                    if (!res.returnData || res.returnData.length == 0) {
                        this.purchaseNumberDisabled = true;
                    }
                });
            },
            getPurchasePlanByApplyIds(applyIds) {
                GetPurchasePlanViewModelByApplyIds({
                    ids: applyIds,
                }).then((res) => {
                    this.form = res.returnData;
                    this.form.applyIds = applyIds.join(';')
                    this.form.createdTime = this.parseTime(new Date());
                    this.form.updateTime = this.parseTime(new Date());
                    this.form.createdUserName = this.userInfo.name;
                    this.form.ownerDeptName = this.userInfo.deptName;
                    this.getLocations(this.form.warehouseId);
                    this.form.details.forEach((e, index) => {
                        e.$index = index + 1;
                        this.getGoods(e, 2);
                    });
                    // this.form.applyDetails = this.form.applyDetails
                });
            },
     
            getPressingStateClass(state) {
                if (state == 1) {
                    return "forbidden";
                }
            },
            handleClose() {
                this.correctBox = false
                this.dialogVisible = false
            },
     
        },
    };
    </script>
     
    <style lang="scss" scoped>
    /deep/.el-dialog__body {
        overflow: auto !important;
    }
     
    /deep/.el-input-number .el-input__inner {
        text-align: left !important;
    }
    </style>
